<template>
	<div
		class="site_button"
		:class="[theme, type]"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		ref="site_button"
	>
		<!-- <span v-html="type === 'close' ? 'Close' : 'Menu'"></span> -->

		<svg
			v-if="type === 'close'"
			xmlns="http://www.w3.org/2000/svg"
			width="25.414"
			height="25.414"
			viewBox="0 0 25.414 25.414"
		>
			<g
				id="Close"
				transform="translate(0.707 0.707)"
			>
				<line
					id="Line_3"
					data-name="Line 3"
					y1="24"
					x2="24"
					fill="none"
					stroke="#3c3c3c"
					stroke-width="3"
				/>
				<line
					id="Line_4"
					data-name="Line 4"
					y1="24"
					x2="24"
					transform="translate(24) rotate(90)"
					fill="none"
					stroke="#3c3c3c"
					stroke-width="3"
				/>
			</g>
		</svg>

		<svg
			v-if="type === 'open'"
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="14"
			viewBox="0 0 24 15"
		>
			<g
				id="Hamburger"
				transform="translate(0 1)"
			>
			<line
					id="Line_3"
					data-name="Line 3"
					x2="48"
					transform="translate(0 16)"
					fill="none"
					stroke="#003c46"
					stroke-width="2"
				/>
				<line
					id="Line_2"
					data-name="Line 2"
					x2="48"
					transform="translate(0 8)"
					fill="none"
					stroke="#003c46"
					stroke-width="2"
				/>
				<line
					id="Line_1"
					data-name="Line 1"
					x2="48"
					fill="none"
					stroke="#003c46"
					stroke-width="2"
				/>
			</g>
		</svg>

	</div>
</template>

<script>
import Close from '../../images/close_X.svg';
import Open from '../../images/menu.svg';

export default {
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
			open: Open,
			close: Close,
		};
	},

	props: {
		label: {},
		theme: {
			default: 'light',
		},
		type: {
			default: 'normal',
		},
	},

	computed: {},

	watch: {
		link() {
			this.button_link = this.link;
		},
	},

	methods: {
		checkEmpty(e) {
			if (this.button_link.url === '#') {
				// this.$refs.site_button.removeAttribute('href');
				e.preventDefault();
			}
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button {
	display: inline-flex;
	transition: 0.2s ease all;
	text-decoration: none;
	justify-content: flex-start;
	position: relative;
	border-radius: 32px;
	background: transparent;
	align-items: center;

	.scrolled & {
		background: var(--orange);
		padding: 12px 24px 10px;

		span {
			color: var(--purple);
		}

		svg {
			display: flex;

			&::v-deep {
				line {
					stroke: var(--navy);
				}
			}
		}
	}

	@media (hover) {
		&:hover {
			transition: 0.2s ease all;
			cursor: pointer;

			span {
				transition: 0.2s ease all;
			}
		}
	}

	&:disabled {
		opacity: 0.5;
	}

	span {
		font: normal normal bold 14px/20px var(--primary-font-family);
		text-transform: uppercase;
		transition: 0.2s ease all;
		margin-right: 0;
		position: relative;
		z-index: 10;
		color: white;
	}

	svg {
		display: flex;
		width: 24px;
		height: 24px;

		&::v-deep {
			line {
				stroke: var(--orange);
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/MenuButton.vue